
import { defineComponent } from "vue";
import SectionDivisor from "./SectionDivisor.vue";

export default defineComponent({
  components: { SectionDivisor },
  data() {
    return {
      missions: [
        {
          title: "Missão",
          description:
            "Simplificar a jornada do cliente com produtos e serviços de qualidade.",
          image: "missao.svg"
        },
        {
          title: "Visão",
          description:
            "Estar entre as cinco maiores empresas do mercado em que atuamos, sempre com o cliente e o colaborador no centro dos nossos negócios.",
          image: "visao.svg"
        },
        {
          title: "Valores",
          description:
            "- Pessoas em 1º lugar;\n" +
            "- Foco no cliente;\n" +
            "- Agilidade;\n" +
            "- Confiança e transparência;\n" +
            "- Compromisso com os resultados;\n" +
            "- Determinação e disciplina.",
          image: "valores.svg"
        }
      ]
    };
  }
});
